import { CompanyAutocompleteField, DEFAULT_OPTION, withFieldGroup } from '@massilia/features'
import { Button } from '@massilia/ui'
import { CreditCard, Plus, Trash2 } from 'lucide-react'

import type { ReservationSchema } from '@/lib/schemas'

/** Les cartes de fidélité d'un passager, telles que le schéma de réservation les décrit. */
interface FidelityCardsValues {
  fidelityCards: ReservationSchema['passengers'][number]['fidelityCards']
}

export const FidelityCardsFormGroup = withFieldGroup({
  defaultValues: {} as FidelityCardsValues,
  render: function FidelityCards({ group }) {
    return (
      <group.AppField mode="array" name="fidelityCards">
        {(fieldArray) => {
          const cards = fieldArray.state.value ?? []

          return (
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-xs font-medium tracking-wider text-stone-500 uppercase">
                  Cartes de fidelite
                </span>
                <Button
                  className="h-7 gap-1 text-xs text-blue-600 hover:text-blue-800"
                  onClick={() => {
                    fieldArray.pushValue({
                      cardNumber: '',
                      company: DEFAULT_OPTION,
                    })
                  }}
                  size="sm"
                  type="button"
                  variant="ghost"
                >
                  <Plus className="size-3.5" />
                  Ajouter
                </Button>
              </div>

              {cards.length === 0 && (
                <p className="text-xs text-stone-400 italic">Aucune carte de fidelite</p>
              )}

              {cards.map((_card, cardIndex) => (
                <div
                  className="space-y-2 rounded-lg border border-stone-200 bg-stone-50/50 p-3"
                  key={cardIndex}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1.5">
                      <CreditCard className="size-3.5 text-stone-400" />
                      <span className="text-xs font-medium text-stone-600">
                        Carte {cardIndex + 1}
                      </span>
                    </div>
                    <Button
                      className="h-6 w-6 p-0 text-red-400 hover:text-red-600"
                      onClick={() => fieldArray.removeValue(cardIndex)}
                      size="sm"
                      type="button"
                      variant="ghost"
                    >
                      <Trash2 className="size-3.5" />
                    </Button>
                  </div>

                  <div className="grid grid-cols-2 gap-2">
                    <group.AppField
                      name={`fidelityCards[${cardIndex}].company`}
                      children={() => (
                        <CompanyAutocompleteField label="Compagnie" valueField="id" />
                      )}
                    />
                    <group.AppField
                      name={`fidelityCards[${cardIndex}].cardNumber`}
                      children={(field) => (
                        <field.TextField
                          icon={CreditCard}
                          label="Numero de carte"
                          placeholder="12987654321"
                        />
                      )}
                    />
                  </div>
                </div>
              ))}
            </div>
          )
        }}
      </group.AppField>
    )
  },
})
